<div class="page-padding">
  <fgbcl-lottos-wallet-details [lottoId]="id"></fgbcl-lottos-wallet-details>
</div>
